import React from 'react';

interface NavbarProps {
  scrolled: boolean;
}

const Navbar: React.FC<NavbarProps> = ({ scrolled }) => {
  return (
    <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-[#0a0a0a]/80 backdrop-blur-md py-4 border-b border-white/5' : 'bg-transparent py-8'}`}>
      <div className="container mx-auto px-6 md:px-12 flex justify-between items-center">
        <div className="text-xl md:text-2xl font-bold tracking-tighter font-syne group cursor-pointer uppercase">
          LAYER<span className="text-neutral-500 group-hover:text-white transition-colors">ONE</span> MANAGEMENT
        </div>
        
        <div className="hidden md:flex items-center space-x-12 text-[10px] font-bold tracking-[0.3em] uppercase">
          <a href="#services" className="hover:text-neutral-400 transition-colors">Services</a>
          <a href="#philosophy" className="hover:text-neutral-400 transition-colors">Philosophy</a>
          <a href="#lab" className="hover:text-neutral-400 transition-colors">Strategy Lab</a>
          <a href="#contact" className="px-6 py-2 border border-white/20 rounded-full hover:bg-white hover:text-black transition-all duration-300">Inquire</a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;